"use client"

import { createContext, useContext } from "react"
import { useCountry } from "@/components/layout/country-provider"
import { defaultBookingFlow, type BookingFlow } from "@/lib/membership-first"

/**
 * Whether the page inside keeps the current booking flow on the
 * membership-first site. Every page books into the new app (lib/membership-
 * first.ts); a page that has not been reworked for it yet, such as
 * /go/heart-health until it gets the offer card with the scan and calcium
 * score picked (Eugene, 15.10), wraps itself in this to keep opening
 * booking.aheadhealth.com.
 */
const LegacyBookingContext = createContext(false)

export function BookingFlowProvider({
  legacy,
  children,
}: {
  legacy: boolean
  children: React.ReactNode
}) {
  return (
    <LegacyBookingContext.Provider value={legacy}>
      {children}
    </LegacyBookingContext.Provider>
  )
}

/** The booking flow the CTAs on this page open: the market's, unless the
 *  page keeps the current one (BookingFlowProvider). */
export function useBookingFlow(): BookingFlow {
  const { code: country } = useCountry()
  const legacy = useContext(LegacyBookingContext)
  return legacy ? "legacy" : defaultBookingFlow(country)
}
